<script setup>
import { __, __x } from 'JIX/gettext';
import DsSmallTip from 'JIX/components/ds/DsSmallTip.vue';
</script>

<template>
    <DsSmallTip
        :heading-tag="'Tip'"
        heading="Jobs For Ukraine"
        dismissable
    >
        <div class="mb-2">
            {{ __('Find ledige stillinger til ukrainske flygtninge eller se hvordan du kan hjælpe ukrainerne ind på det danske arbejdsmarked.') }}
        </div>
        <a href="/cms/jobs-for-ukraine" class="btn btn-primary btn-sm">
            {{ __('Gå til') }}
            Jobs For Ukraine
        </a>
    </DsSmallTip>
</template>
